const createNRAttribute = (actionName, stepToRender, errCode = '0') => {
  const { payload = {}, type } = stepToRender;
  const { callbacks = [], stage, authId } = payload;

  let stageToUse = stage;

  // check for KBA page or email sent page (as those do not have stage names)
  if (callbacks.length > 0 && !stageToUse) {
    if (callbacks[0]?.type?.toLowerCase() === 'kbacreatecallback') {
      stageToUse = 'SecurityQuestions';
    }

    if (callbacks[0]?.type?.toLowerCase() === 'suspendedtextoutputcallback') {
      stageToUse = 'EmailSent';
    }
  }

  if (typeof window.newrelic === 'object' && actionName && stepToRender) {
    window.newrelic.addPageAction(actionName, {
      authId,
      errCode,
      stage: stageToUse,
      stepType: type,
    });
  }
};

export default createNRAttribute;
